import { render, staticRenderFns } from "./chulist.vue?vue&type=template&id=15a6aa88&scoped=true&"
import script from "./chulist.vue?vue&type=script&lang=js&"
export * from "./chulist.vue?vue&type=script&lang=js&"
import style0 from "./chulist.vue?vue&type=style&index=0&id=15a6aa88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6aa88",
  null
  
)

export default component.exports